module.exports = __webpack_public_path__ + "static/media/profile.cd9174db.svg";